import React from "react";
import {render} from "react-dom";
import {AppProvider} from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import {BrowserRouter} from "react-router-dom";
import App from "./App";
import ReactDOM from 'react-dom/client';
import { createApp } from "@shopify/app-bridge";


const urlParams = new URLSearchParams(window.location.search);

const config = {
    apiKey: process.env.MIX_SHOPIFY_API_KEY || '',
    host: urlParams.get('host') ?? '',
    forceRedirect: true,
};



const app = createApp(config);
window.app = app;

ReactDOM.createRoot(document.getElementById('app')!)
    .render(
        <BrowserRouter>
            <AppProvider i18n={enTranslations}>
                <App />
            </AppProvider>
        </BrowserRouter>,
    );